window.pa = window.pa || {};
window.pa.product = (function(jQuery, pa) {
    'use strict';

    function ProjectsAbroadProduct() {
        var global = {
            headerOffset: 30,
            skipSticky: false,
            scrollTrigger: false,
        };

        var fn = {
            init: function() {
                var sidebarElem = jQuery('.TypeSidebarContainer');
                var productIntroButtons = jQuery('.TypeSidebarContainer__Btns');
                if (!sidebarElem.length || !productIntroButtons.length) {
                    return;
                }

                var sidebarWrapper = sidebarElem.parents(
                    '.TypeText--intro-prices'
                );

                function onScrollWithArgs() {
                    fn.onScroll(sidebarElem);
                }
                function onResizeWithArgs() {
                    fn.onResize(
                        sidebarElem,
                        productIntroButtons,
                        sidebarWrapper
                    );
                }

                onResizeWithArgs();
                jQuery(window).on(
                    'scroll',
                    pa.helper.debounce(onScrollWithArgs, 2)
                );

                jQuery(window).on(
                    'resize',
                    pa.helper.debounce(onResizeWithArgs, 200)
                );

                pa.helper.debounce(onResizeWithArgs, 200);
            },

            onResize: function(
                sidebarElem,
                productIntroButtons,
                sidebarWrapper
            ) {
                fn.calculateScrollOffsets(
                    sidebarElem,
                    productIntroButtons,
                    sidebarWrapper
                );
                fn.onScroll(sidebarElem);
            },

            calculateScrollOffsets: function(
                sidebarElem,
                productIntroButtons,
                sidebarWrapper
            ) {
                sidebarElem.removeClass('is-sticky');

                var sectionHeight = sidebarWrapper.height();
                var sidebarHeight = sidebarElem.height();
                if (sectionHeight <= sidebarHeight) {
                    global.skipSticky = true;
                    return;
                } else {
                    global.skipSticky = false;
                }

                var headerHeight =
                    jQuery('.main-header').height() +
                    jQuery('.info-bar').height();
                global.scrollTrigger =
                    productIntroButtons.position().top -
                    headerHeight -
                    global.headerOffset;
                sidebarElem.css('top', headerHeight + global.headerOffset);
            },

            onScroll: function(sidebarElem) {
                var notMobile = pa.helper.checkWindowWidth(768);
                if (!notMobile) {
                    return;
                }

                if (global.skipSticky) {
                    return;
                }

                var scrollPos = window.scrollY;
                if (scrollPos > global.scrollTrigger) {
                    sidebarElem.addClass('is-sticky');
                } else {
                    sidebarElem.removeClass('is-sticky');
                }
            },
        };

        jQuery(fn.init);
    }

    return new ProjectsAbroadProduct();
})($, pa);
